import { IFormInfo } from '../form-fileds.model';

export const EN_SAF_FORM_INFO: IFormInfo = {
  name: {
    label: 'Your Name',
    placeholder: 'Enter Your Name',
    readOnly: false,
    errMsg: {
      required: 'please enter your name',
      pattern: 'please enter valid name',
      minLength: 'name must have atleast 3 characters'
    }
  },
  email: {
    label: 'Email',
    placeholder: 'Enter Email',
    readOnly: false,
    errMsg: {
      required: 'please enter your email',
      pattern: 'please enter valid email'
    }
  },
  raisingFor: {
    label: 'Who are you raising funds for?',
    placeholder: '',
    readOnly: false,
    options: [
      { value: 'self', label: 'Myself', icon: 'people' },
      { value: 'someoneElse', label: 'Someone else', icon: 'people' },
      { value: 'ngo', label: 'NGO/Charity', icon: 'people' }
    ],
    errMsg: {
      required: 'please select an option'
    }
  },
  ngo: {
    label: 'NGO Name',
    placeholder: 'Enter Name',
    readOnly: false,
    errMsg: {
      required: 'please search and select your NGO',
      ngoNotFound:'ngo is not registered',
      custom: 'please select another NGO'
    }
  },
  relation: {
    label: 'The funds are for my...',
    placeholder: 'OR SELECT OTHER',
    readOnly: false,
    priorOptions: [
      { value: 'Mother', label: 'Mother' },
      { value: 'Father', label: 'Father' },
      { value: 'Son', label: 'Son' },
      { value: 'Daughter', label: 'Daughter' },
      { value: 'Friend', label: 'Friend' },
    ],
    options: [
      { value: 'Aunt', label: 'Aunt' },
      { value: 'Brother', label: 'Brother' },
      { value: 'Cousin', label: 'Cousin' },
      { value: `Friend's Family`, label: `Friend's Family` },
      { value: 'Granddaughter', label: 'Granddaughter' },
      { value: 'Grandfather', label: 'Grandfather' },
      { value: 'Grandmother', label: 'Grandmother' },
      { value: 'Grandson', label: 'Grandson' },
      { value: 'Husband', label: 'Husband' },
      { value: 'Legal ward', label: 'Legal ward' },
      { value: 'Nephew', label: 'Nephew' },
      { value: 'Niece', label: 'Niece' },
      { value: 'Relative', label: 'Relative' },
      { value: 'Sister', label: 'Sister' },
      { value: 'Twins', label: 'Twins' },
      { value: 'Uncle', label: 'Uncle' },
      { value: 'Wife', label: 'Wife' },
      { value: 'Pet', label: 'Pet' },
      { value: 'Other', label: 'Other' },
    ],
    errMsg: {
      required: 'please select an option'
    }
  },
  beneficiaryName: {
    label: `Beneficiary's Name`,
    placeholder: `Enter Beneficiary's Name`,
    readOnly: false,
    errMsg: {
      required: `please enter beneficiary's name`,
      pattern: 'please enter valid name',
      minLength: 'name must have atleast 3 characters'
    }
  },
  age: {
    label: 'Age Group?',
    options: [
      { value: '0-5', label: '0-5 years', icon: 'person' },
      { value: '5-18', label: '5-18 years', icon: 'person' },
      { value: '18-60', label: '18-60 years', icon: 'person' },
      { value: '60+', label: '60+ years', icon: 'person' },
    ],
    errMsg: {
      required: 'please select an option'
    }
  },
  fundRequired: {
    label: 'How much do you want to raise?',
    prefix: '₹',
    placeholder: '000000',
    readOnly: false,
    note: 'You can add an approximate figure for now and change it later. Should be minimum ₹2000',
    errMsg: {
      required: 'please enter amount',
      min: 'please enter amount greater than or equall to ₹2000',
      max: 'please enter amount less than or equall to ₹5,00,00,000'
    }
  },
  cause: {
    label: 'Which of these best describes the purpose of your fundraiser?',
    readOnly: false,
    showMore: 'View more causes',
    showLess: 'View less causes',
    errMsg: {
      required: 'please select an option'
    }
  },
  ailment: {
    label: 'Ailment / Medical Condition',
    placeholder: 'search and select option',
    readOnly: false,
    errMsg: {
      required: 'please enter and select an option'
    }
  },
  hospitalisation: {
    label: 'What is your hospitalisation status?',
    readOnly: false,
    options: [
      {
        value: 'Recently discharged from the hospital',
        label: 'recently discharged ',
        icon: 'people',
      },
      {
        value: 'Currently hospitalised',
        label: 'currently hospitalised',
        icon: 'people',
      },
      {
        value: 'Will be hospitalised soon',
        label: 'will be hospitalised',
        icon: 'people',
      },
    ],
    lowPriorOptions: [
      {
        value: 'Does not require hospitalisation',
        label: 'Does not require hospitalisation',
        icon: 'block',
      },
    ],
    errMsg: {
      required: 'please select an option'
    }
  },
  hospital: {
    label: 'Hospital Name',
    placeholder: 'Select Hospital',
    readOnly: false,
    errMsg: {
      required: 'please enter and select an option'
    }
  },
  sameCityAsHospital: {
    label: 'I am in the same city as the hospital',
    readOnly: false
  },
  city: {
    label: 'City',
    placeholder: 'Enter City',
    readOnly: false,
    errMsg: {
      required: 'please enter city',
      custom: 'please select a valid city'
    }
  },
  title: {
    label: 'Fundraiser Title',
    placeholder: 'Enter title',
    readOnly: false,
    errMsg: {
      required: 'please enter title',
      minLength: 'minimum 5 characters required',
      maxLength: 'maximum {MAX_LENGTH} characters allowed'
    }
  },
  about: {
    label: 'We wrote your story—edit anytime',
    label1: 'Explain why this fundraiser is important to you.',
    label2: 'Tell your Story',
    placeholder: 'Write a story that does justice to your cause and makes the supporter click the contribute button.',
    readOnly: false,
    errMsg: {
      required: 'Field is required',
      minLength: 'minimum 50 characters required'
    }
  },
  aboutMerge: {
    label: 'What will the funds be used for?',
    placeholder: 'Tuition, travel, books etc',
    readOnly: false,
    errMsg: {
      required: 'please enter more details'
    }
  },
  media: {
    label: `Upload photo to support your cause <span class="optional">(Optional)</span>`,
    readOnly: false
  },
  insuranceOptIn: {
    label: `I consent to raising funds for a <strong>₹1.2 lakh insurance cover</strong> for a family member of my choice.`,
    readOnly: false,
  },
  agree: {
    label: `I agree to Ketto's <a href="{{terms}}" target="_blank">Terms of use</a>, <a href="{{privacy}}" target="_blank">Privacy Policy</a> and <a href="{{plans}}" target="_blank">Plans & Pricing</a>. I acknowledge and confirm that the information provided above is true and correct to the best of my knowledge and belief and I agree to be liable if any of the above information is found to be false or misleading. I hereby give my consent for sharing it with regulatory authorities or disclosing it as may be required by law.`,
    readOnly: false,
    errMsg: {
      required: 'please read and select agreement'
    }
  }
};

export const EN_OTHER_INFO = {
  verifyEmail: {
    title: `Once confirmed you can't change the email`,
    confirm: 'Confirm',
    edit: 'edit'
  },
  verifyEmailOTP: {
    title: `Enter the OTP sent to`,
    confirm: 'Verify',
    edit: 'Edit Email'
  }
}